<template>
  <div class="basic-block block-title">
    <p class="block-title__sub">〈完全無料〉</p>
    <h1 class="block-title__title">
      あなたの可能性を極限化<br>
      <b>斗弥の属性開抛（ぞくせいかいほう）</b><br>
      占い体験！
    </h1>
  </div>
</template>

<script>
export default {
  name: 'BlockTitle',
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  computed: {
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
.block-title {
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  padding: 20px 0;
  color: $l_col_keycolor;
  background: #FFFBE3;
  &__sub {
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    margin: 0 0 8px;
    font-feature-settings: "palt";
    letter-spacing: 0.5px;
  }
  &__title {
    margin: 0;
    font-weight: bold;
    font-size: 14px;
    line-height: 25.5px;
    font-feature-settings: "palt";
    letter-spacing: 0.5px;
    > b {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockTitle.vue